import store from '@/store'
// import productConn from '@/connection/productsv2'
import axios from 'axios'
import ProductConn from '@/connection/productsv2'
const sleep = m => new Promise(r => setTimeout(r, m))

export default {

  async getAllOffers () {
    if (!store.getters.getOffers.length) {
      if(!store.state.fetchingAllOffers) {
        store.state.fetchingAllOffers = true
        let response = await axios.get(store.getters.getOffersApi + '/offer-list?company_id=' + store.getters.getCompanyId)
        if (response.data && response.data.length) {
          //let allProductsData = await ProductConn.getAll()
          //let allProducts = allProductsData.data
          store.state.activateOffers = true
          response.data.sort((a, b) => a.order - b.order)
          response.data.forEach(async (offer) => {
            offer.products_offers.sort((a, b) => a.order - b.order)
            let allProducts = await ProductConn.getProductsByIds(offer.products_offers.map(p => p.product_id))
            offer.products_offers.forEach( (product) => {
              let globalProduct = allProducts.filter(p => p.id === product.product_id)[0]
              if (globalProduct) {
                product.name = globalProduct.name
                if (globalProduct.photos && globalProduct.photos.length) {
                  product.img = globalProduct.photos[0].id
                } else {
                  product.img = null
                }
                product.inactive = false
              } else {
                product.inactive = true
              }
            })
            offer.products_offers = offer.products_offers.filter(p => p.inactive === false)
          })
          store.state.offers = response.data
          store.state.fetchingAllOffers = false
          return store.state.offers
        }
      } else {
        return this.awaitFromOffersFromCache()
      }
    } else {
      return store.state.offers
    }
  },

  async awaitFromOffersFromCache () {
    if (!store.state.offers.length) {
      await sleep(50)
      return this.awaitFromOffersFromCache()
    } else {
      return store.state.offers
    }
  },

  async getAllUserOffers (offerId) {
    try {
      let result = await axios.get(store.getters.getOffersApi + '/offer-list/' + offerId + '/cpf/' + store.state.user.cpf)
      if (result.data) {
        return result.data
      } else {
        console.log('erro errado')
        return {error:true, msg:'Erro obtendo ofertas ativas'}
      }
    } catch(e) {
      console.log(e)
      if (e.errorCode) {
        return {error:false, products_ids: []}
      } else {
        return {error:true, msg:'Erro obtendo ofertas ativas'}
      }
    }
  },

  async activateOffer(offerId, productId) {
    let offer = store.state.offers.filter(o => o.id === offerId)[0]
    for (let x=0; x<offer.products_offers.length; x++){
      if (offer.products_offers[x].product_id === productId) {
        try {
          let result = await axios.post(store.getters.getOffersApi + '/offer-list/' + offerId + '/activate',
          {
            "user_id": store.state.user.id,
            "cpf": store.state.user.cpf,
            "product_id": productId
          }
          )
          if (result.data) {
            offer.products_offers[x].active = true
            return result.data
          } else {
            return {error: true}
          }
        } catch(e) {
          let error = {e}
          let msg = 'Erro inesperado'
          if (error.e && error.e.errorCode === 652){
            msg = 'Não existe mais códigos disponíveis para esse produto'
          }
          return {error: true, obj:error, msg: msg}
        }
      }
    }
    console.log('product not found')
    return {error: true}
  }
}
